<template>
  <gj-modal
      :visible.sync="modalVisible"
      @cancel="cancel"
      @confirm="confirm"
      @open="modalOpen"
      size="full-middle"
      :contentStyle="{'height': '100%', display: 'flex', 'flex-direction': 'column'}"
      notFooterPadding
  >
    <template #header>添加产品</template>
    <template #content>
      <div style="margin-bottom: 12px">
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 'sku', text: 'SKU'},
              {id: 'productName', text: '产品名称'},
            ]"
            @input="debounceQuery"
        ></gj-select-input>
      </div>
      <div style="flex: 1; overflow: auto;">
        <gj-table
            ref="gjTable"
            :index="false"
            :columns="type === documentTypeEnum.INBOUND ? columns1 : columns2"
            :data="data"
            :offset-height="54"
            adapt-parent
            selection
            :loading="loading"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
          <template v-slot:productInfo="{row}">
            <div>
              <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
            </div>
            <div>
              <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
            </div>
          </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "../../../../../minxins";
  import {documentTypeEnum} from "../enum";
  import {getCanOtherInboundProductPage, getCanOtherOutboundProductPage} from "../../../../../api/warehouse";
  import {ProductEnum} from "../../../../../utils/options";

  export default {
    name: "inbound-outbound-add-product",
    mixins: [modalMixIn, selectionMixin, queryMixin],
    props: {
      type: null,
      hideSkuList: null,
      warehouseId: null,
    },
    data() {
      return {
        columns1: [
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称', field: 'slot:productInfo', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
        ],
        columns2: [
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称', field: 'slot:productInfo', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'changeQuantity', header: '库存可用量', field: 'availableQuantity', minWidth: '100px', align: 'right'},
          {id: 'changeBadQuantity', header: '库存次品量', field: 'unsellableQuantity', minWidth: '100px', align: 'right'},
        ],
        data: [],
        documentTypeEnum: documentTypeEnum,
        keyword: {
          key: 'sku',
          value: null,
        },
        debounceQuery: this._.debounce(this.$gjNoticeQuery, 500),
      }
    },
    methods: {
      $gjQuery() {
        this.sort.prop = 'sku';
        this.loading = true;
        const params = {
          model: {
            hideSkuList: this.hideSkuList,
            warehouseId: this.warehouseId,
          },
          ...this.querySort,
          ...this.queryPagination,
        };
        params.model[this.keyword.key] = this.keyword.value;
        if (this.type === this.documentTypeEnum.INBOUND) {
          getCanOtherInboundProductPage(params)
            .then((data) => {
              this.data = data.records;
              this.pagination = this.getPagination(data);
            }).complete(() => this.loading = false)
        } else {
          getCanOtherOutboundProductPage(params)
            .then((data) => {
              this.data = data.records;
              this.pagination = this.getPagination(data);
            }).complete(() => this.loading = false)
        }
      },
      confirm() {
        this.$emit('addConfirm', this.selectedRows || []);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
